/** @jsxImportSource @emotion/react */
import React from 'react';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { di, TitleWrap } from 'components/layouts/Dialog';
import { ImgBox } from 'components/layouts/Board';
import { useTranslation } from 'react-i18next';
import { Padding } from '@mui/icons-material';

type Props = {
  open: boolean;
  close: () => void;
};

/**
 * UT 작성 화면 배기량가이드
 * @param props
 * @constructor
 */
export const DisplacementGuidePopup = ({ open, close }: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} css={di.dialog} fullWidth className="lg" maxWidth={false}>
      <TitleWrap>
        <h2>{t('ut.label.배기량가이드', '배기량가이드')}</h2>
        <Button onClick={() => close()} disableRipple />
      </TitleWrap>
      <DialogContent>
        <ImgBox>
          <img src="/assets/diplacementGuide.png"></img>
        </ImgBox>
      </DialogContent>
    </Dialog>
  );
};
